import { render } from "./value-settinggr.vue?vue&type=template&id=253038e0"
import script from "./value-settinggr.vue?vue&type=script&lang=js"
export * from "./value-settinggr.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__